import type { DateRangeType } from '@medly-components/core';
import { ScatterPlot as NivoScatterPlot, type ScatterPlotSvgProps } from '@nivo/scatterplot';
import { add, sub } from 'date-fns';
import { useMemo } from 'react';
import { getDatesArray } from 'utils';
import { EmptyGraph } from '../EmptyGraph';
import { NodeType } from '../hooks/useScatterPlotGraphHook';

export const EmptyScatterPlot = ({
    height,
    graphDates,
    ...props
}: Partial<ScatterPlotSvgProps<any>> & {
    width: number;
    height: number;
    emptyText?: string;
    graphDates?: DateRangeType;
}) => {
    const emptyDateData = useMemo(
        () => [
            {
                id: 'empty',
                data:
                    (graphDates?.startDate &&
                        graphDates?.endDate && [
                            {
                                x: sub(graphDates?.startDate, { days: 1 }),
                                y: NodeType.UP_ARROW,
                                nodeType: NodeType.EMPTY_NODE
                            },
                            ...getDatesArray(graphDates!.startDate!, graphDates!.endDate!).map((date, index) => ({
                                x: date,
                                y: index,
                                nodeType: NodeType.EMPTY_NODE
                            })),
                            {
                                x: add(graphDates?.endDate, { days: 1 }),
                                y: NodeType.DOWN_ARROW,
                                nodeType: NodeType.EMPTY_NODE
                            }
                        ]) ||
                    []
            }
        ],
        [graphDates]
    );
    return (
        <>
            <NivoScatterPlot<any>
                {...{
                    ...props,
                    height,
                    data: emptyDateData,
                    axisLeft: {
                        tickPadding: 12,
                        renderTick: () => <></>
                    },
                    nodeComponent: () => null
                }}
            />
            <EmptyGraph text={props.emptyText} height={height - 100} />
        </>
    );
};
